module.exports = __webpack_public_path__ + "assets/img/img-map-kumamoto.2f4a590c.svg";